module.exports = __webpack_public_path__ + "img/congratulations.7f025b55.svg";